import ParkingIndicator from './ParkingIndicator';

export default ParkingIndicator;
